import { toast } from "react-toastify";
import { removePropertiesRecursive } from "../../../services/functions";
import mainAxios from "../../../services/mainAxios";
import { normalizeTransportDocumentDates } from "../transportDateUtils";

export const duplicateInvoice=({state,company,t,user,onSuccess})=>{
    const {
      recordDate,
      recordUser,
      modificationDate,
      modificationUser,
      tiOrderNum,
      tiNum,
      tiic,
      ftiic,
      send,
      qrUrl,
      fiscStatus,
      errorMessage,
      einvoice,
      ...restInvoice
    } = state;

    const pathsToPreservId = ['items'];
    const cleanedRestInvoice = removePropertiesRecursive(restInvoice, pathsToPreservId);
    const currentDate = new Date();

    cleanedRestInvoice.status = {
      id: 7,
      status: "DRAFT",
    };

    cleanedRestInvoice.items = cleanedRestInvoice.items.map((items) => {
      const { id, ...restItems } = items;
      return restItems;
    })
    cleanedRestInvoice.address[0].date = currentDate;
    cleanedRestInvoice.address[1].date = null;
    cleanedRestInvoice.issueDate = currentDate;
    cleanedRestInvoice.internalId = null;

    if (cleanedRestInvoice.parties.transporter.idType) cleanedRestInvoice.parties.transporter.idType = cleanedRestInvoice.parties.transporter.idType.trim();
    if (cleanedRestInvoice.parties.transporter.name) cleanedRestInvoice.parties.transporter.name = cleanedRestInvoice.parties.transporter.name.trim();
    if (cleanedRestInvoice.parties.seller.name) cleanedRestInvoice.parties.seller.name = cleanedRestInvoice.parties.seller.name.trim();

    return mainAxios
      .post("apiEndpoint/saveOrUpdate", {
        object: "CustomTI",
        content: {
          ...cleanedRestInvoice,
          itemsNum: cleanedRestInvoice?.items.length,
        },
        nuis: company.nuis.trim(),
      })
      .then((res) => {
        if (res?.data?.status === true) {
          toast.success(t(['invoice.isInvoiceDuplicated']), { containerId: "all_toast" })
          onSuccess(res)
        }
      })
}


export const getTransportInvoice=({id,onSuccess})=>{
        return mainAxios.post("apiEndpoint/search", {
            object: "GetCustomTI",
            params: {
                id
            }
        }).then(res => {
            if (res?.data?.status) {
                const content = normalizeTransportDocumentDates(res.data?.content?.[0])
                if(onSuccess) onSuccess(content)
                return content
            }
            return null
        })
        .catch(()=>{
            return null
        })
    }
